<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters,mapActions,mapState } from "vuex"
import Swal from "sweetalert2";
import DataTable from "@/components/DataTable.vue";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Sales",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      title: "Sales Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Sales Report",
          active: true,
        },
      ],
      totalRows: 1,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      AllSaleHeldServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      heldColumns: [
      { key: "index", label: "S/N", sortable: true },
      { key: "name", label: "NAME", sortable: false },
      { key: "qty", label: "QUANTITY", sortable: false },
      { key: "price", label: "UNIT PRICE", sortable: false },
      { key: "total_price", label: "TOTAL PRICE", sortable: false },
      { key: "dateAdded", label: "DATE", sortable: true },
      { key: "identification", label: "IDENTIFICATION", sortable: true },
      { key: "user", label: "USER", sortable: true },
      { key: "actions", label: "ACTIONS", sortable: false },
    ],

      // delete item
      deletedata: {
        name: "",
        id: "",
      },
      unhold: {
        id: "",
      },
      deleteholddata: {
        id: "",
      },
      add: {
        id: "",
        quantity_taken: "",
        product: "",
        unit: "",
        quantity: 1,
        instock: "",
        type: "",
      },
      unitsArr: [],
      qtyError: "",
      unitError: "",
      itemError: "",
      data: {
        page: 1,
        per_page: 50,
      },
    };
  },

  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("saledetails", ["SaveStatus","Sales"]),
    ...mapGetters("sales", ["SaveStatus","AllSaleHeld","Products", "AllSaleHeldPagination","AllSaleHeldPaginated","filterStatus"]),


    rows() {
      return this.AllSaleHeldServerPaginated
          ? this.AllSaleHeldPagination?.total
          : this.AllSaleHeld ? this.AllSaleHeld.length : 0;
    },

     perPage: {
      get() {
        if (this.AllSaleHeldServerPaginated) {
          return (
            (this.AllSaleHeldPagination && this.AllSaleHeldPagination.per_page) ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.AllSaleHeldServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchSalesHeld(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.AllSaleHeldPaginated && this.AllSaleHeldPagination
          ? this.AllSaleHeldPagination.current_page
          : 1;
      },
      set(value) {
        if (this.AllSaleHeldPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },

  updated() {
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
            this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  methods: {
    ...mapActions({
      FetchSalesHeld: "sales/fetchAllHeld",
      FetchProducts: "sales/fetchItems",
      AddCart1: "sales/addToCart1",
      UnHold: "sales/unHoldSale",
      AddOrder: "sales/addHold",
      DeleteHold: "sales/deleteHold",
      EditPaid: "saledetails/editAmtPaidMode",
      EditSale: "saledetails/editSale",
      DeleteSale: "saledetails/deleteSale",

    }),
    /**
     * Search the table data with search input
     */
     onFiltered() {
      if (!this.AllSaleHeldServerPaginated) {
        this.clientCurrentPage = 1;
      }
    },
    // COMMA SEPERATORS
    thousandSeperator  (m) {
    return m != null && m !== ""
      ? m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      : m;
    },

    assignArr2(){
        let selectedPdt = this.Products.filter((product)=>{
            return product.id == this.add.product;
        })
        this.unitsArr = selectedPdt[0].units;
        this.add.type = selectedPdt[0].type;
        this.add.unit = this.unitsArr[0].id;
        this.add.instock = selectedPdt[0].instock;
    },

    validateQty2(){
        if(this.add.product && this.add.quantity && this.add.unit && this.add.type==1){
            let tot = this.unitsArr.filter((unit)=>{
                return unit.id == this.add.unit;
            });
            let totEqv = tot[0].base_qty*this.add.quantity;
            if(totEqv > this.add.instock){
                this.qtyError = "Quantity Out Of Range";
                return;
            }
            else{
                this.qtyError = "";
            }
        }
    },

    resetErrors() {
        this.itemError = "";
        this.unitError = "";
        this.qtyError = "";
    },

    resetModal() {
        this.add.id = "";
    this.add.product = "";
    this.add.quantity = "";
    this.add.unit = "";
    },

    showDeleteModal(data) {
      this.deletedata.name = data.name;
      this.deletedata.id = data.id;
    },
    showAddModal(data) {
      this.add.id = data.id;
    },
    showUnHoldModal(data) {
      this.unhold.id = data.id;
    },
    showDeleteHoldModal(data) {
      this.deleteholddata.id = data.id;
    },
    resetDeleteItem() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
    },
    addToCart1(model) {
      this.modal_id = model;
      if (this.add.product == "") {
        this.itemError = "Product is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.add.quantity == "") {
        this.qtyError = "Quantity is required";
        return;
      } else {
        this.qtyError = "";
      }
      this.validateQty2();
      this.AddCart1(this.add);
    },
    UnHoldOrder(mod){
      this.modal_id = mod;
      this.UnHold(this.unhold);
    },
    deleteHeldItem(mod){
      this.modal_id = mod;
      this.DeleteHold(this.deleteholddata);
    },

    redirect(value) {
      this.$router.push(
        `/hold/print/${btoa(value)}`
      );
    },

    closeModal(modalId) {
      this.resetErrors();
      this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    handlePageChange(newPage) {
      if (this.AllSaleHeldServerPaginated) {
        this.data.page = newPage;
        this.FetchSalesHeld(this.data);
      }
    },

  },

  created() {
    this.FetchSalesHeld(this.data);
    this.FetchProducts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">Held Sales Report</h4>
              </div>
              <div class="col-md-3" align="right">
                  <button size="sm" @click="$router.go(-1)" class="btn btn-primary mb-2">
                        <i class="fas fa-arrow-circle-left"></i> Go Back
                    </button>
              </div>

            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
            <DataTable
            :columns="heldColumns"
            :rows="AllSaleHeld || []"
            :total-rows="rows"
            :pagination="AllSaleHeldPagination"
            :server-pagination="AllSaleHeldServerPaginated"
            :loading="filterStatus"
            row-class="held-sales-table-bordered"
          >
            <!-- Index / Serial Number -->
            <template #cell(index)="{ row, index }">
              {{ AllSaleHeldPagination.from + index }}
            </template>

            <template #cell(name)="{ row }">
              <div v-for="(det, idx) in row.items" :key="idx" class="mb-4">
                <div>{{ det.name }}</div>
              </div>
            </template>

            <template #cell(qty)="{ row }">
              <div v-for="(det, idx) in row.items" :key="idx" class="mb-4">
                {{ det.quantity }}{{ det.unit }}
              </div>
            </template>

            <template #cell(price)="{ row }">
              <div v-for="(det, idx) in row.items" :key="idx" class="mb-4">
                {{ det.selling ? thousandSeperator(det.selling) : 0 }}
              </div>
            </template>
                             
            <template #cell(total_price)="{ row }">
              <div v-for="(det, idx) in row.items" :key="idx" class="mb-4">
                {{ det.selling?thousandSeperator(det.selling*det.quantity):0 }}
              </div>
            </template>

            <!-- Total Amount -->
            <template #cell(tt_amt)="{ value }">
              {{ thousandSeperator(value) }}
            </template>

            <!-- Amount Paid -->
            <template #cell(amt_paid)="{ row, value }">
              <span
                class="text-warning"
                v-b-modal.expired-modal
                @click="ShowEdit(row)"
                v-if="row.numpaid < 0"
              >
                {{ thousandSeperator(value) }}
              </span>
              <span v-else>
                {{ thousandSeperator(value) }}
              </span>
            </template>

            <!-- Discount -->
            <template #cell(discount_field)="{ value }">
              {{ thousandSeperator(value) }}
            </template>

            <!-- Date -->
            <template #cell(dateAdded)="{ value }">
              {{ value }}
            </template>

            <!-- Identification -->
            <template #cell(identification)="{ value }">
              {{ value }}
            </template>

            <!-- User -->
            <template #cell(user)="{ value }">
              {{ value }}
            </template>

            <!-- Actions -->
            <template #cell(actions)="{ row }">
              <b-button-group>
                  <b-button
                    v-b-modal.unhold-item-modal
                    variant="success"
                    size="sm"
                    @click="showUnHoldModal(row)"
                    ><i class="fa fa-undo"></i>UnHold</b-button
                  >
                  <b-button
                    v-b-modal.add-item-modal
                    variant="info"
                    size="sm"
                    @click="showAddModal(row)"
                    ><i class="fa fa-plus"></i>Add</b-button
                  >
                  <b-button
                    size="sm"
                    variant="primary"
                    @click="redirect(row.id)"
                    ><i class="fa fa-print"></i> Print</b-button
                  >
                  <b-button
                    v-b-modal.delete-hold-item-modal
                    variant="danger"
                    size="sm"
                    @click="showDeleteHoldModal(row)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                  </b-button-group>
             
            </template>
          </DataTable>

            </div>
            
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

        <!-- modal delete expense starts -->
    <b-modal id="unhold-item-modal" hide-footer>
      <template #modal-title class="text-danger">UnHold Order</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Are you sure you want to UnHold this Order?.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('unhold-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="UnHoldOrder('unhold-item-modal')"
        >
          <i class="fa fa-check"></i> UnHold
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="UnHolding"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
        <!-- modal delete expense starts -->
    <b-modal id="delete-hold-item-modal" hide-footer>
      <template #modal-title class="text-danger"> Delete Held Order</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to this Order? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-hold-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteHeldItem('delete-hold-item-modal')"
        >
          <i class="fa fa-trash"></i> Delete
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal for adding items -->
    <b-modal id="add-item-modal" hide-footer @hidden="resetModal()">
      <template #modal-title class="text-primary">
        Add Item to this Order</template
      >
      <div class="form-group mb-3">
          <label>Product <span class="text-danger">*</span></label>
          <model-list-select
          :list="Products ? Products : []"
          v-model="add.product"
          option-value="id"
          option-text="name2"
          placeholder="Select Product"
          @input="resetErrors(),assignArr2()"
          >
          </model-list-select>
          <div class="text-danger" v-if="itemError">
          <em>{{ itemError }}</em>
          </div>
      </div>
      <div class="row">
        <div class="col-md-6">
            <div class="form-group mb-3">
              <label>Quantity</label>
              <input
                type="number"
                class="form-control"
                step="any"
                v-model="add.quantity"
                @keyup.enter="addToCart1()"
                @input="resetErrors(),validateQty2()"
              />
            </div>
            <div class="text-danger" v-if="qtyError">
              <em>{{ qtyError }}</em>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group mb-3">
                <label>Unit Measure <span class="text-danger">*</span></label>
                <model-list-select
                :list="unitsArr ? unitsArr : []"
                v-model="add.unit"
                option-value="id"
                option-text="unitsym"
                placeholder="Unit"
                @input="resetErrors()"
                @keyup.enter="addToCart1()"
                >
                </model-list-select>
                <div class="text-danger" v-if="unitError">
                  <em>{{ unitError }}</em>
                </div>
            </div>
        </div>

      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="addToCart1('add-item-modal')"
        >
          <i class="fa fa-plus"></i> Add Item
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Adding"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
.held-sales-table-bordered td {
  border-bottom: 1px solid #000 !important;
}
</style>
